// Xử lý các chức năng liên quan đên hạch toán đồng thời

// import { useExportAsync } from '@/setup/utilities/exportAsync.js';
import { MSConstant } from '@/commons/wildcards';
import exportApi from '@/apis/import/exportAPI.js';

// const { exportGridExcel } = useExportAsync();

/**
 * Kiểm tra 2 row có trùng nhau về MLNS, cấp phát, nghiệp vụ, CTMT không
 * @param {*} rowParallelOfRule
 * @param {*} rowParalleInVoucher
 */
const checkDuplicateParallel = (rowParallelOfRule, rowParalleInVoucher) => {
  let columnNames = [
    MSConstant.ColumnCommon.budgetSourceId,
    MSConstant.ColumnCommon.budgetChapterCode,
    MSConstant.ColumnCommon.budgetSubKindItemCode,
    MSConstant.ColumnCommon.budgetItemCode,
    MSConstant.ColumnCommon.budgetSubItemCode,
    MSConstant.ColumnCommon.budgetDetailItemCode,
    MSConstant.ColumnCommon.budgetFeesCode,
    MSConstant.ColumnCommon.topicCode,
    MSConstant.ColumnCommon.cashWithdrawTypeId,
    MSConstant.ColumnCommon.methodDistributeType,
    MSConstant.ColumnCommon.projectCode,
    MSConstant.ColumnCommon.debitAccount,
    MSConstant.ColumnCommon.creditAccount,
    MSConstant.ColumnCommon.taskCode,
  ];
  for (const column of columnNames) {
    if (!rowParallelOfRule[column] && !rowParalleInVoucher[column]) {
      continue;
    }

    if (rowParallelOfRule[column] != rowParalleInVoucher[column]) {
      return false;
    }
  }
  return true;
};

/**
 * Xử lý thêm dòng để xuất ra excel
 */
const addRowCompareParallel = (rowParallelInVoucher, rowParallelOfRule, isDuplicate, isParallelInVoucher) => {
  let rowSource = {};
  if (isDuplicate || !isParallelInVoucher) {
    rowSource = rowParallelOfRule;
  } else {
    rowSource = rowParallelInVoucher;
  }

  let rowCompare = { ...rowSource };

  if (isDuplicate || !isParallelInVoucher) {
    rowCompare.debit_account_of_rule = rowSource.debit_account;
    rowCompare.debit_account_in_voucher = rowParallelInVoucher.debit_account;
  } else {
    rowCompare.debit_account_in_voucher = rowSource.debit_account;
  }

  if (isDuplicate || !isParallelInVoucher) {
    rowCompare.credit_account_of_rule = rowSource.credit_account;
    rowCompare.credit_account_in_voucher = rowParallelInVoucher.credit_account;
  } else {
    rowCompare.credit_account_in_voucher = rowSource.credit_account;
  }

  if (isDuplicate || !isParallelInVoucher) {
    rowCompare.amount_of_rule = rowSource.amount || rowSource.amount_oc;
    rowCompare.amount_in_voucher = rowParallelInVoucher.amount || rowParallelInVoucher.amount_oc;
  } else {
    rowCompare.amount_in_voucher = rowSource.amount || rowSource.amount_oc;
  }

  rowCompare.diff_amount = (rowCompare.amount_of_rule || 0) - (rowCompare.amount_in_voucher || 0);

  return rowCompare;
};

/**
 * Xuất chênh lệch hạch toán đồng thời
 * @param {*} parallelOfRule
 * @param {*} parallelInVoucher
 */
export const exportDifferenceParallel = (parallelOfRule, parallelInVoucher, noneItems) => {
  // exportGridExcel(columns, data, 'CHÊNH LỆCH HẠCH TOÁN ĐỒNG THỜI');

  let dictionaryParalleInVoucher = {};

  parallelOfRule = parallelOfRule.sortObject('budget_sub_item_code');
  parallelInVoucher = parallelInVoucher.sortObject('budget_sub_item_code');

  let exportData = [];
  // Chuyển DL hạch toán đồng thời theo quy tắc và hạch toán đồng thời trên chứng từ vào bảng xuất khẩu Excel
  let index = 0;
  for (const rowParallelOfRule of parallelOfRule) {
    let rowCompare = {};
    // Biến này xác định 2 row có trùng nhau không
    let isDuplicate = false;
    // Duyệt từng dòng hạch toán đồng thời trên chứng từ kiểm tra có dòng nào trùng với hạch toán đồng thời theo quy tắc không
    for (let index = 0; index < parallelInVoucher.length; index++) {
      const rowParalleInVoucher = parallelInVoucher[index];
      if (
        //NVTUAN1 01.03.2024: Sử dụng hàm hasOwnProperty không ảnh hưởng bởi PBI 419812
        !dictionaryParalleInVoucher.hasOwnProperty(rowParalleInVoucher.ref_detail_id) &&
        checkDuplicateParallel(rowParallelOfRule, rowParalleInVoucher)
      ) {
        isDuplicate = true;
        rowCompare = addRowCompareParallel(rowParalleInVoucher, rowParallelOfRule, isDuplicate, false);
        dictionaryParalleInVoucher[rowParalleInVoucher.ref_detail_id] = true;
        break;
      }
    }
    // Nếu k tìm thấy row nào trùng thì add riêng row rowParallelOfRule
    if (!isDuplicate) {
      rowCompare = addRowCompareParallel({}, rowParallelOfRule, isDuplicate, false);
    }
    rowCompare.sort_order = index;
    index++;
    exportData.push(rowCompare);
  }

  // Lấy những row đồng thời trên chứng từ còn lại không trùng
  for (const rowParalleInVoucher of parallelInVoucher) {
    let rowCompare = {};
    //NVTUAN1 01.03.2024: Sử dụng hàm hasOwnProperty không ảnh hưởng bởi PBI 419812
    if (!dictionaryParalleInVoucher.hasOwnProperty(rowParalleInVoucher.ref_detail_id)) {
      rowCompare = addRowCompareParallel(rowParalleInVoucher, {}, false, true);
      rowCompare.sort_order = index;
      index++;
      exportData.push(rowCompare);
    }
  }

  // for (const noneItem of noneItems) {
  //   let rowCompare = {}
  //   rowCompare = addRowCompareParallel(noneItem, {}, false, true);
  //   rowCompare.sort_order = index;
  //   index++;
  //   exportData.push(rowCompare);
  // }

  exportApi.exportCustomTemplate('account_parallel_diff', exportData, '');
  // exportApi.exportGrid(columns, exportData, 'CHÊNH LỆCH HẠCH TOÁN ĐỒNG THỜI');
};
